import React, { useState, useEffect } from "react";
import PhotoGallery from "./component/PhotoGallery";
import Info from "./component/Info";
import { useProductos } from "../../hooks/useProductos";
import { useForm } from "../../hooks/useForm";
import { Link, useNavigate, useParams } from "react-router-dom";
import AccordionBike from "../Accordion";
import Model from "./component/Model";
import DrawerMenu from "./component/DrawerMenu";
// import { FirstProductImage } from "./component/data";
import './component/indexs.css'
import Loader from "../Loader";
import { bikes } from "../../utils/data";

const Product = ({ comprar_ahora }) => {
  const { cart, productos, producto, addCart, getProducto, formatoCOP } = useProductos();
  const { form, onChange } = useForm({ cantidad: 1, size: JSON.parse(producto?.tallas)[0]?.name });
  const { cantidad, size } = form;
  const [color, setColor] = useState({
    dataC: '',
    index: 0
  })

  const [indexImage, setIndexImage] = useState(0);
  const [count, setCount] = useState(1);
  const [open, setOpen] = useState(false);
  const [draw, setDraw] = useState(false);
  const handleOpen = () => setOpen(true);
  const { id } = useParams();
  const images = typeof producto?.img === "string" ? JSON.parse(producto?.img) : producto?.img;
  const [bgimage, setBgimage] = useState(null);
  const [parsedImages, setParsedImages] = useState(null);
  const [dimensions, setDimensions] = useState([])

  const [isLoading, setIsLoading] = useState(true);

  const colores = [...new Set(producto.inventarios.map(objeto => objeto.color))];

  console.log(producto)
  useEffect(() => {
    if (images?.length > 0 && images[0]?.url) {
        setBgimage(images[0].url?.secure_url);
        setColor({
          dataC: colores[0],
          index: 0
        })
    } else {
        setBgimage('');
    }
}, [producto]);

  

  useEffect(() => {
    setParsedImages(images)
  }, [])


  
  const data = {
    description: {
      h1: `${producto?.nombre}`,
      peso: `${producto?.peso}`,
      tenedor: `${producto?.tenedor}`,
      tipoDeMarco: `${producto?.tipo_marco}`,
      tamañoDeLasLlantas: ``,
      frenos: `${producto?.frenos}`,
      grupo: `${producto?.grupo}`,
      manubrio: `${producto?.manubrio}`,
      tamañoDelMarco: `${producto?.tamaño_marco}`
    },
    dimensions: dimensions,
    heights: [450, 480, 500, 520],
    price: `${producto?.precio}`,
    tallas: producto?.tallas,
    peso: `${producto?.peso}`,
    bikes: images?.map((data, index) => {
      return {
        id: index + 1, // Asigna un id único basado en el índice
        color: index === 0 ? `rgb(70, 73, 77)` : index === 1 ? `rgb(10, 66, 84)` : `rgb(255, 255, 255)`,
        image: data?.secure_url
      };
    })
  }

  const cellStyle = {
    padding: '8px',
    borderBottom: '1px solid #eee',
  };

  const labelStyle = {
    fontWeight: 'bold',
    color: '#555',
  };




  useEffect(() => {
    if (id) {
      getProducto(id);
    }
  }, [id]);


  return (
    <main style={{ paddingBottom: '100px' }}>

      <div className="Main-hero">
        <Model open={open} setOpen={(word) => setOpen(word)} />
        <DrawerMenu draw={draw} setDraw={(word) => setDraw(word)} />
        <section className="flexHero">
          <div style={{ marginInline: '30px', display: "flex", flexDirection: "column", alignItems: "center" }}>

            <PhotoGallery
              bgimage={bgimage}
              images={parsedImages}
              producto={producto}
              handleOpen={handleOpen}
              setBgimage={setBgimage}
              setIsLoading={setIsLoading}
              isLoading={isLoading}
            />

            <div className="buttons-color" style={{ marginTop: "30px" }}>


            </div>

            <div style={{ width: '400px', marginTop: "30px" }} className="information">

              <AccordionBike data={data}></AccordionBike>
            </div>

          </div>
          <div style={{ justifyContent: "center", display: "flex", width: "100%" }} className="information-desktop">

            <Info
              comprar_ahora={comprar_ahora}
              count={count}
              size={size}
              addCart={addCart}
              onChange={onChange}
              cantidad={cantidad}
              producto={producto}
              formatoCOP={formatoCOP}
              images={images}
              setCount={(word) => setCount(word)}
              setColor={setColor}
              color={color}
              setBgimage={setBgimage}
              colores={colores}
            />

          </div>

          <div className="information-mobile">

            <div style={{ width: '400px', display: "flex", justifyContent: "center" }} >

              <AccordionBike data={data}></AccordionBike>

            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Product;